"use client";

import React from "react";
import { Leaf, Flower2, Sprout, Trees } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const pillars = [{
  title: "Věkové Omezení",
  description: "Vstup do našeho salonu je povolen pouze osobám starším 18 let. Při pochybnostech můžeme vyžadovat platný doklad totožnosti.",
  icon: Leaf
}, {
  title: "Zdravotní Stav",
  description: "Klient je povinen informovat masérku o veškerých zdravotních omezeních, alergiích či těhotenství před zahájením procedury.",
  icon: Flower2
}, {
  title: "Profesionální Hranice",
  description: "Naše služby jsou striktně relaxační a terapeutické. Jakékoli nevhodné chování povede k okamžitému ukončení masáže bez náhrady.",
  icon: Sprout
}, {
  title: "Bez Sexuálních Služeb",
  description: "Důrazně upozorňujeme, že neposkytujeme žádné služby sexuálního charakteru. Respektujeme integritu našich masérek.",
  icon: Trees
}];
export default function TheCuratedExperience() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: cardRef,
    isVisible: isCardVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="243017" id="liability-disclaimers" className="relative w-full overflow-hidden bg-[#26262b] py-24 md:py-[160px]">
      <div className="mx-auto max-w-7xl px-6 md:px-8">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-12 lg:gap-0">
          
          {}
          <div ref={textRef} className={`z-20 self-center transition-all duration-1000 ease-out lg:col-span-5 lg:col-start-1 lg:row-start-1 lg:-mr-12 ${isTextVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
            <h2 className="font-default leading-[0.9] tracking-tighter text-white !text-left !text-6xl !m-0 !w-[310px]">
              Právní ujednání a pravidla.
            </h2>
            <p className="mt-8 max-w-md font-default text-xl leading-relaxed text-gray-400 !h-[172px] !w-[390px]">
              Vaše bezpečnost a komfort jsou naší prioritou. Prosíme o důkladné seznámení s našimi provozními pravidly a etickým kodexem salonu.
            </p>
            <div className="mt-12 pointer-events-auto">
              <Button asChild variant="outline" size="lg" className="rounded-none border-primary/40 px-8 py-6 font-default text-sm tracking-widest uppercase text-white hover:bg-primary hover:text-primary-foreground">
                
              </Button>
            </div>
          </div>

          {}
          <div ref={cardRef} className={`z-10 transition-all delay-300 duration-1000 ease-out lg:col-span-8 lg:col-start-5 lg:row-start-1 ${isCardVisible ? "translate-y-0 opacity-100" : "translate-y-16 opacity-0"}`}>
            <Card className="rounded-none border-none bg-[#1e1e21] p-8 shadow-4xl md:p-16 lg:pl-24">
              <CardContent className="p-0">
                <div className="grid grid-cols-1 gap-12 sm:grid-cols-2 md:gap-16">
                  {pillars.map((pillar, i) => {
                  const Icon = pillar.icon;
                  return <div key={i} data-index={i} className="group flex flex-col border-l-2 border-primary/30 pl-6 transition-colors duration-300 hover:border-primary">
                        <div className="mb-6 inline-flex h-12 w-12 items-center justify-center rounded-full bg-primary/10 transition-colors duration-500 group-hover:bg-primary/20">
                          <Icon className="size-6 text-primary stroke-[1.5px]" />
                        </div>
                        <h3 className="mb-3 font-default text-2xl font-bold text-white">
                          {pillar.title}
                        </h3>
                        <p className="font-default text-base leading-relaxed text-gray-400">
                          {pillar.description}
                        </p>
                      </div>;
                })}
                </div>
              </CardContent>
            </Card>
          </div>

        </div>
      </div>
    </section>;
}